import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { QuillModule } from 'ngx-quill';

@Component({
  selector: 'app-add-news',
  standalone: true,
  imports: [
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    QuillModule,
  ],
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddNewsComponent {
  @Input() title: string = 'Newsticker List';
  @Input() initialValue: string = '';
  @Output() submitForm = new EventEmitter<any>();
  @Output() backtolist = new EventEmitter<void>();

  form: FormGroup;

  quillConfig = {
    toolbar: [['bold', 'italic'], [{ link: true }]],
  };

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      sentence: ['', Validators.required],
    });
  }

  ngOnInit() {
    if (this.initialValue) {
      this.form.patchValue({ sentence: this.initialValue });
    }
  }

  goBack() {
    this.backtolist.emit()
  }

  createNewticker() {
    if (this.form.valid) {
      this.submitForm.emit(this.form.value);
    }
  }

  setQuillInstance(q: any) {}
  onContentChanged(e: any) {}
  onSelectionChanged(e: any) {}
}
